import React from "react";

import { ColoredAvatar } from "./ColoredAvatar";
import { avatarColors } from "./avatarColors";
import { StyledAvatar } from "./styled";

export const Avatar = ({
  firstName = "",
  lastName = "",
  fullName = "",
  index,
  defaultAvatarIcon,
  isEmptyAvatar
}) => {
  if (isEmptyAvatar) {
    return (
      <StyledAvatar data-testid="empty-avatar">
        {defaultAvatarIcon && (
          <img src={defaultAvatarIcon} alt="defaultIcon" className={"defaultAvatar"} />
        )}
      </StyledAvatar>
    );
  }

  const firstAndLastName = fullName ? fullName.split(/\s/) : [firstName, lastName];
  const initials = firstAndLastName.map(name => name.charAt(0)).join("");
  return (
    <ColoredAvatar color={avatarColors[(index || 0) % avatarColors.length]}>
      {initials}
    </ColoredAvatar>
  );
};
